import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import * as XLSX from 'xlsx';

import * as Excel from "exceljs/dist/exceljs.min.js";
import * as moment from 'moment';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() {
    
   }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    fs.saveAs(data, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
  }

  generateSettlementDetailsExcel(data,accountName,created,completed,totalVal,totalNeto,accountstatus) {
    
    const header = ["FECHA","OPERACIÓN","REFERENCIAL DE OPERACIÓN","CLIENTE",	"INVOICE ID", "REFERENCIA DE ORDEN",	"DESCRIPCIÓN", "NOMBRE DE LA ORDEN",	"TOTAL", "REFERENCIA"]
   
    //Create workbook and worksheet
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    //Add Row and formatting
    worksheet.addRow(['Liquidación',accountName]);
    worksheet.addRow(['Estado',accountstatus]);
    // worksheet.addRow([]);
    let CreatedVal=created;
    let CompleVal= completed;
    let TotalVal= totalVal;
    let TotalNeto = totalNeto;
    worksheet.addRow(['Creación',CreatedVal,'','','','Total',TotalVal])
    worksheet.addRow(['Completado',CompleVal,'','','','Total Neto',TotalNeto])


    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);

    headerRow.font = { size: 12, bold: true,align:'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
    
    data.forEach(d => {
      worksheet.addRow(d);

    }
    );
    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.addRow([]);
    
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      fs.saveAs(blob, 'SettlementDetail.xlsx');

    })
  }

  generateExcelForInvalidData(header, data,name){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.eachRow(function (row) {
      row.eachCell(function (cell, colNumber) {
        if (cell.value == 'Dato inválido')
          row.getCell(colNumber).font = { color: { argb: "FF260E" } };
      });
    });

    
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
     // fs.saveAs(blob, 'Payout Process Import- TEST.xlsx');
      fs.saveAs(blob, name + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateExcelForPayoutImportError(header, data){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.eachRow(function (row) {
      row.eachCell(function (cell, colNumber) {
        if (cell.value == 'Dato inválido')
          row.getCell(colNumber).font = { color: { argb: "FF260E" } };
      });
    });

    
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
     // fs.saveAs(blob, 'Payout Process Import- TEST.xlsx');
      fs.saveAs(blob, "Payout Process Import" + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  public exportAsExcelFileForPayoutProcessView(json: any[], excelFileName: string): void {

    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFileForPayoutProcessView(excelBuffer, excelFileName);
  }

  private saveAsExcelFileForPayoutProcessView(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    fs.saveAs(data, fileName + EXCEL_EXTENSION);
  }


  generateSettlementViewExcel_V2(data,header,accountName,created,completed,totalCredit,totalDebit,totalNet,accountStatus) {
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    worksheet.addRow(['Liquidación',accountName]);
    worksheet.addRow(['Estado',accountStatus])
    // worksheet.addRow([]);
    // let CreatedVal=created;
    // let CompleVal= completed;
    // let TotalVal= totalVal;
    // let TotalNeto = totalNeto;
    worksheet.addRow(['Creación',created,'','','','','Total Créditos',totalCredit])
    worksheet.addRow(['Completado',completed,'','','','','Total Débitos',totalDebit])
    worksheet.addRow(['',,'','','','','Total Neto',totalNet])


    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);

    headerRow.font = { size: 12, bold: true,align:'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';

    data.forEach(d => {
      worksheet.addRow(d);

    }
    );
    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.addRow([]);
    
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      fs.saveAs(blob, 'SettlementDetail_v2.xlsx');

    })
  }

  generateExcelFile(header, data, fileName){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    data.forEach(d => {
      worksheet.addRow(d);
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  dateFormat = async function (date, format) {
    return moment(date).format(format);
  }
  
  generateInvoicesExcelFile(header, data, fileName, app){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }
    
    

    if (app == 'CORPORATE') {
      worksheet.getColumn('D').numFmt = 'DD/MM/YYYY HH:mm:ss';
      worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
      worksheet.getColumn('C').numFmt = 'DD/MM/YYYY HH:mm:ss';
    } else {
      worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
      worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
      worksheet.getColumn('C').numFmt = 'DD/MM/YYYY HH:mm:ss';
    }

    data.forEach(d => {
      worksheet.addRow(d);
    });

   // worksheet.getCell("A2").value = '20-01-2022  23:19:44';
    //worksheet.getCell('A2').numFmt = 'm/d/yyyy\\ h:mm:ss\\ AM/PM'; // I think this is right ;-)


    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA DE CREACION' || cell.value == 'EMPRESA' 
        || cell.value == 'VENCIMIENTO' || cell.value == 'EXPIRACION' || cell.value == 'EXPIRACION'
        || cell.value == 'ID ORDEN DE PAGO' || cell.value == 'DESCRIPCIÓN' || cell.value == 'NOMBRE CLIENTE' ){
          maxLength = 23;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateCustomerInvoicesExcelFile(header, data, fileName, app){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }
    
    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    
    data.forEach(d => {
      worksheet.addRow(d);
    });

   
    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA DE CREACION'){
          maxLength = 23;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateCustomersExcelFile(header, data, fileName, app){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    if(app == 'CORPORATE') {
      worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
    }else{
      worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    }
      
    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA CREACION' || cell.value == 'EMPRESA' 
        || cell.value == 'NUMERO DOCUMENTO' || cell.value == 'EMAIL' || cell.value == 'NOMBRE'){
          maxLength = 20;
        }

        if( cell.value == 'EMAIL' || cell.value == 'NOMBRE'){
          maxLength = 40;
        }
      });
      column.width = maxLength < 15 ? 15 : maxLength;
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateAccountOperationPayoutExcelFile(header, data, fileName){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';

    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA DE OPERACIÓN' || cell.value == 'DESCRIPCIÓN' 
        || cell.value == 'REFERENCIA'){
          maxLength = 20;
        }
      });
      column.width = maxLength < 15 ? 15 : maxLength;
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateSettlementExcelFile(header, data, fileName){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';

    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA DE LIQUIDACIÓN' || cell.value == 'FECHA DE TRANSFERENCIA' 
        || cell.value == 'REFERENCIA' || cell.value == 'OPERACION' || cell.value == 'CUENTA'){
          maxLength = 20;
        }
      });
      column.width = maxLength < 15 ? 15 : maxLength;
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generatePaymentListExcel(header, data){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    
    data.forEach(d => {
      worksheet.addRow(d);
    });

    worksheet.eachRow(function (row) {
      row.eachCell(function (cell, colNumber) {
        if (cell.value == 'Reverso'){
          row.getCell(colNumber).font = { color: { argb: "FF260E" } };
          row.getCell(9).font = { color: { argb: "FF260E" } };
        }
      });
    });

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        if(cell.value == 'FECHA DE REGISTRO' || cell.value == 'REFERENCIA DE PAGO' 
        || cell.value == 'CLIENTE' || cell.value == 'REFERENCIA DE ORDEN' || cell.value == 'DESCRIPCIÓN' || cell.value == 'MÉTODO DE PAGO'){
          maxLength = 20;
        }
      });
      column.width = maxLength < 15 ? 15 : maxLength;
    });
    
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, "PaymentList" + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateNotificationExcelFile(header, data, fileName){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('C').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('D').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('E').numFmt = 'DD/MM/YYYY HH:mm:ss';

    data.forEach(d => {
      worksheet.addRow(d);
    });
    
    worksheet.columns.forEach(function (column, i) {
      column.width = 20;
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

  generateKashioExcelFile(header, data, fileName){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    worksheet.getColumn('A').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('B').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('C').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('D').numFmt = 'DD/MM/YYYY HH:mm:ss';
    worksheet.getColumn('E').numFmt = 'DD/MM/YYYY HH:mm:ss';

    data.forEach(d => {
      worksheet.addRow(d);
    });
    
    worksheet.columns.forEach(function (column, i) {
      column.width = 20;
    });

    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      fs.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }
}